import "./App.css";
import "./globals.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import HomePage from "./pages/HomePage";
import NavigationPage from "./pages/NavigationPage";
import ModelViewerPage from "./pages/ModelViewerPage";
import ModelViewerWithCustomPathPage from "./pages/ModelViewerWithCustomPathPage";
import ReconstructionPage from "./pages/ReconstructionPage";
import SightlineVerifierPage from "./pages/SightlineVerifierPage";
import PlaygroundPage from "./pages/PlaygroundPage";
import CrimeScenePage from "./pages/CrimeScenePage";
import HomeVoicePage from "./pages/HomeVoicePage";
import ShareNavPage from "./pages/ShareNavPage";
import LoadingPage from "./pages/LoadingPage";
import ExplorationPage from "./pages/ExplorationPage";
import ShareSimPage from "./pages/ShareSimPage";
import SimulationChatPage from "./pages/SimulationChatPage";
import { useEffect } from "react";
import useMessagePlayer from "./hooks/useMessagePlayer";
import { useAudioStore } from "./store/audioStore";
import Explore3DPage from "./components/exploration/exploration-layout";
import ShareExplorePage from "./pages/ShareExplorePage";
import ExplorationFlutterPage from "./pages/ExplorationFlutterPage";
import PoliceOperationsPage from "./pages/PoliceOperationsPage";
import ExplorationMapFlutterPage from "./components/explorationFlutter/explorationMapFlutter";
import ChatBotPage from "./pages/ChatBotPage";
import AugmentedRealityViewerPage from "./pages/AugmentedRealityViewerPage"
import BeetleDeepLink from "./pages/BeetleDeepLink";
import InvitePage from "./pages/InvitePage";
import { trackPageView } from "./amplitudeClient";

function AmplitudeRouteTracker() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);
  return null;
}

function App() {
  const { cancelReading } = useMessagePlayer();
  const setStop = useAudioStore((s) => s.setStop);

  useEffect(() => {
    const handleUnload = () => {
      cancelReading();
      console.log("handleUnload setStop")
      setStop();
    };
    // const resizeObserverError = (e: any) => {
    //   if (
    //     e.message.includes(
    //       "ResizeObserver loop completed with undelivered notifications"
    //     )
    //   ) {
    //     console.log("caught resize error");
    //     e.stopImmediatePropagation();
    //     e.preventDefault();
    //   }
    // };
    // window.addEventListener("error", resizeObserverError);

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden") {
        console.log("App went to background (hidden)");
        cancelReading();
        setStop();
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    window.addEventListener("unload", handleUnload);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("unload", handleUnload);
      // window.removeEventListener("error", resizeObserverError);
    };
  }, []);

  return (
    <Router>
      {/* <AmplitudeRouteTracker /> */}
      {/* "/link" is reserved for the backend's short link redirect (ShortLinkController) — do not add a route with that path here. */}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/home/voice" element={<HomeVoicePage />} />
        <Route path="/navigation" element={<NavigationPage />} />
        <Route path="/simulation" element={<CrimeScenePage />} />
        <Route path="/simulation/chat" element={<SimulationChatPage />} />
        <Route path="/explore/:venueCode" element={<ExplorationPage />} />
        <Route path="/explore3d/:venueCode" element={<Explore3DPage />} />
        <Route path="/modelViewer" element={<ModelViewerPage />} />
        <Route path="/modelViewerWithCustomPath" element={<ModelViewerWithCustomPathPage />} />
        <Route path="/reconstruction" element={<ReconstructionPage />} />
        <Route path="/sightlineVerifier" element={<SightlineVerifierPage />} />
        <Route path="/playground" element={<PlaygroundPage />} />
        <Route path="/policeOperations/:operation" element={<PoliceOperationsPage />} />
        <Route path="/shareNavigation" element={<ShareNavPage />} />
        <Route path="/shareSimulation" element={<ShareSimPage />} />
        <Route path="/shareExploration" element={<ShareExplorePage />} />
        <Route path="/loading" element={<LoadingPage />} />
        <Route path="/explorationFlutter" element={<ExplorationFlutterPage />} />
        <Route path="/explorationMapFlutter" element={<ExplorationMapFlutterPage />} />
        <Route path="/chatbot" element={<ChatBotPage />} />
        <Route path="/AugmentedRealityViewer" element={<AugmentedRealityViewerPage />} />
        <Route path="/shareModel/:id" element={<BeetleDeepLink />} />
        <Route path="/invite" element={<InvitePage />} />
        {/* You can add a catch-all route for 404 pages */}
        {/* <Route path="*" element={<NotFoundPage />} /> */}
      </Routes>
    </Router>
  );
}

export default App;
